import { render, staticRenderFns } from "./MLC_0900.vue?vue&type=template&id=241004bc&scoped=true"
import script from "./MLC_0900.vue?vue&type=script&lang=ts"
export * from "./MLC_0900.vue?vue&type=script&lang=ts"
import style0 from "./MLC_0900.vue?vue&type=style&index=0&id=241004bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241004bc",
  null
  
)

export default component.exports